import { action } from 'satcheljs/lib/legacy';
import {
    createLocationPersonaFromPersonaType,
    LocationPersonaControlViewState,
} from 'owa-location-persona';
import LocationPersonaType from 'owa-calendar-scheduling-service/lib/schema/LocationPersonaType';

/**
 * Action to process the results of the FindPlaces service call.
 * It converts the PersonaType to a LocationPersonaControlViewState
 */
export default action('processFindPlacesResult')(function processFindPlacesResult(
    personaTypeSet: LocationPersonaType[],
    findResultSet: LocationPersonaControlViewState[],
    transactionId?: string,
    queryString?: string
) {
    if (personaTypeSet && findResultSet) {
        let index = 0;
        personaTypeSet.forEach(result => {
            let locationPersona = createLocationPersonaFromPersonaType(result);

            // Set up the relevance hint
            if (locationPersona) {
                locationPersona.relevanceData = {
                    relevanceHint: result.RelevanceHint,
                    locationIndex: index,
                    transactionId: transactionId ? transactionId : '',
                    locationFeedbackId: result.FeedbackId,
                    queryString: queryString ? queryString : '',
                };

                index++;
                findResultSet.push(locationPersona);
            }
        });
    }
});
